module.exports = __webpack_public_path__ + "static/media/box.ad53d0de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/box.svg
// module id = 6538
// module chunks = 0